import { ChevronLeftIcon, StackIcon } from "@radix-ui/react-icons";
import { Box, Button, Flex, Text, Tabs } from "@radix-ui/themes";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { useDashboardOrderDetailsQuery } from "@/shared/api";
import { ZoneBasedAnomaly } from "./ui/zone-based-anomaly";
import { PinBasedAnomaly } from "./ui/pin-based-anomaly";
import { OrderDetails } from "./ui/order-details";
import { ReEvaluation } from "./ui/re-evaluation";

export function DashboardOrderDetails() {
  const { orderId = "", storeKey = "" } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const requestId = searchParams.get("request_id");

  const { data, isLoading, status } = useDashboardOrderDetailsQuery(
    {
      id: orderId,
      request_id: requestId ?? undefined,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  return (
    <Flex direction="column" gap="1" p="2" pt="0">
      <Flex justify="between">
        <Button asChild variant="surface" color="gray">
          <Link to={`/stores/${storeKey}/dashboard`}>
            <ChevronLeftIcon />
            Back to Dashboard Orders
          </Link>
        </Button>
        <ReEvaluation
          orderId={orderId}
          requestId={requestId}
          orderRequestHistory={data?.result.order_request_history}
          onSelectHistory={(requestId: string | undefined) => {
            if (requestId) {
              setSearchParams({ request_id: requestId }, { replace: true });
            } else {
              setSearchParams({}, { replace: true });
            }
          }}
        />
      </Flex>

      <Tabs.Root defaultValue="1">
        <Tabs.List size="1">
          <Tabs.Trigger value="1">Dashboard Order Details</Tabs.Trigger>
          <Tabs.Trigger value="2">Zone-Based Anomaly</Tabs.Trigger>
          <Tabs.Trigger value="3">Pin-Based Anomaly</Tabs.Trigger>
        </Tabs.List>

        <Box pt="3">
          <Tabs.Content value="1">
            <OrderDetails
              isLoading={isLoading}
              data={data}
              orderId={orderId}
              status={status}
            />
          </Tabs.Content>

          <Tabs.Content value="2">
            {data?.result.zone_based_anomaly ? (
              <ZoneBasedAnomaly data={data.result.zone_based_anomaly} />
            ) : (
              <Flex
                direction="column"
                py="5"
                justify="center"
                align="center"
                gap="2"
              >
                <StackIcon color="var(--gray-11)" width="2rem" height="2rem" />
                <Text color="gray" size="2">
                  No zone-based anomaly data
                </Text>
              </Flex>
            )}
          </Tabs.Content>

          <Tabs.Content value="3">
            {data?.result.pin_based_anomaly ? (
              <PinBasedAnomaly data={data.result.pin_based_anomaly} />
            ) : (
              <Flex
                direction="column"
                py="5"
                justify="center"
                align="center"
                gap="2"
              >
                <StackIcon color="var(--gray-11)" width="2rem" height="2rem" />
                <Text color="gray" size="2">
                  No pin-based anomaly data
                </Text>
              </Flex>
            )}
          </Tabs.Content>
        </Box>
      </Tabs.Root>
    </Flex>
  );
}
